import {Component, EventEmitter, Input,  Output} from '@angular/core';
import {ThingSettingsInterface} from '@app/app/shared/interfaces/thing/thing-settings.interface';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';

@Component({
  templateUrl: './park-settings-view.html',
  selector: 'park-settings-view'
})

export class ParkSettingsViewComponent {
  @Input() public settings: ThingSettingsInterface;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  @Input() parkId: string;

  public availableLanguages = {
    en: {name: 'English'},
    fr: {name: 'French'},
    ru: {name: 'Russian'}
  };

  constructor(private http: HttpClient,
              private auth: AuthenticationService) {



  }

  public setEditMode() {
    this.getSearchStatusChange.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/settings/view/park-settings-view.component.ts